module.exports = __webpack_public_path__ + "static/pay-de-nuez-con-helado-de-vainilla-1-f2cec96aacd2ce4fdc729e094aefa794.jpg";